import { render, staticRenderFns } from "./newProduct.vue?vue&type=template&id=37b1dd24&scoped=true&"
import script from "./newProduct.vue?vue&type=script&lang=js&"
export * from "./newProduct.vue?vue&type=script&lang=js&"
import style0 from "./newProduct.vue?vue&type=style&index=0&id=37b1dd24&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b1dd24",
  null
  
)

export default component.exports